import {
  Brain, Heart, Eye, Database, Cpu, Activity, Wind, Layers, Users,
  ShieldCheck, ShieldAlert, Dna, ScanLine, Mail, HardDrive, Upload,
  Landmark, CreditCard, FileText, Camera, Inbox,
} from "lucide-react";

export const STATUS = {
  GREEN: { label: "Sotto controllo", color: "#10B981", glow: "rgba(16,185,129,0.4)" },
  YELLOW: { label: "Richiede attenzione", color: "#F59E0B", glow: "rgba(245,158,11,0.4)" },
  RED: { label: "Intervento necessario", color: "#EF4444", glow: "rgba(239,68,68,0.4)" },
  GREY: { label: "Dati insufficienti", color: "#6B7280", glow: "rgba(107,114,128,0.25)" },
};

export const ORGAN_ICONS = {
  Brain, Heart, Eye, Database, Cpu, Activity, Wind, Layers, Users, ShieldCheck, ShieldAlert, Dna,
};

export const CHANNEL_ICONS = {
  scan: Camera, bulk: ScanLine, email: Mail, drive: HardDrive, upload: Upload,
  bank: Landmark, pos: CreditCard, file: FileText, inbox: Inbox,
};

export const CHANNEL_LABELS = {
  scan: "DAD Scan", bulk: "Bulk Scan", email: "Email", drive: "Drive",
  upload: "Upload", bank: "Banca", pos: "POS", file: "File", inbox: "Intake",
};

export const DOC_STATUS = {
  processing: { label: "In elaborazione", color: "#06B6D4" },
  ready: { label: "Pronto", color: "#10B981" },
  to_confirm: { label: "Da confermare", color: "#F59E0B" },
  anomaly: { label: "Anomalia", color: "#EF4444" },
  archived: { label: "Archiviato", color: "#6B7280" },
  discarded: { label: "Scartato (duplicato)", color: "#6B7280" },
  failed: { label: "Elaborazione fallita", color: "#EF4444" },
};

export const ORGAN_LABELS = {
  brain: "Company Brain", eyes_ears: "DAD Intake", memory: "Archivio & Documenti",
  nervous_system: "Motore di Elaborazione", heart: "Finanza & Liquidità",
  circulation: "Contabilità & IVA", breathing: "Vendite & Operazioni",
  digestive: "Acquisti & Fornitori", muscles: "Personale & Payroll",
  skeleton: "Società & Contratti", immune: "Assicurazioni & Compliance",
  dna: "Regole & Configurazione",
};

export const OPTION_LABELS = {
  contanti: "Contanti", carta_aziendale: "Carta aziendale", carta_personale: "Carta personale",
  banca: "Bonifico bancario", altro: "Altro", non_ancora_pagata: "Non ancora pagata",
  pagata: "Sì, già pagata", non_pagata: "No, da pagare",
};

export const TRUST = {
  acquisito: { label: "Dato acquisito", color: "#06B6D4" },
  verificato: { label: "Dato verificato", color: "#10B981" },
  verificato_auto: { label: "Verificato da DAD", color: "#10B981" },
  contabilizzato: { label: "Dato contabilizzato", color: "#3B82F6" },
  dichiarato: { label: "Dato dichiarato", color: "#8B5CF6" },
};

export const LEVEL_COLORS = { green: "#10B981", yellow: "#F59E0B", red: "#EF4444", grey: "#6B7280" };

export const PIPELINE_LABELS = {
  acquisizione: "Acquisizione",
  lettura_ai: "Lettura AI",
  verifica: "Verifica",
  classificazione: "Classificazione",
  contabilizzazione: "Contabilizzazione",
  archiviazione: "Archiviazione",
  collegamento: "Collegamento",
  memoria: "Memoria",
};

export const STAGE_STATUS_LABELS = {
  pending: "In attesa",
  processing: "In elaborazione",
  completed: "Completato",
  requires_confirmation: "Richiede conferma",
  blocked: "Bloccato",
  failed: "Fallito",
  not_applicable: "Non applicabile",
};

export const FACT_TYPE_LABELS = {
  costo_fornitore: "Costo fornitore",
  ricavo_operativo: "Ricavo operativo",
  movimento_bancario: "Movimento bancario",
  costo_personale: "Costo personale",
  copertura_assicurativa: "Copertura assicurativa",
  impegno_contrattuale: "Impegno contrattuale",
  nota_spesa: "Nota spesa",
  altro: "Altro fatto",
};

export const VERIFICATION_LABELS = {
  non_verificato: { label: "Non verificato", color: "#F59E0B" },
  verificato: { label: "Verificato", color: "#10B981" },
};

export const ACCOUNTING_STATUS_LABELS = {
  da_contabilizzare: { label: "Da contabilizzare", color: "#F59E0B" },
  pre_contabilizzato: { label: "Pre-contabilizzato (Registro DAD)", color: "#06B6D4" },
  contabilizzato: { label: "Contabilizzato", color: "#3B82F6" },
  non_richiesto: { label: "Non richiesto", color: "#6B7280" },
};

export const PAYMENT_STATUS_LABELS = {
  open: { label: "Da pagare", color: "#F59E0B" },
  paid: { label: "Pagata", color: "#10B981" },
  declared_paid: { label: "Pagata (dichiarata)", color: "#06B6D4" },
  da_rimborsare: { label: "Da rimborsare", color: "#F59E0B" },
  non_determinato: { label: "Da determinare", color: "#6B7280" },
};

export const INTAKE_STATUS = {
  planned: { label: "Pianificato — non ancora attivo", color: "#6B7280" },
  not_configured: { label: "Non configurato", color: "#F59E0B" },
  connected: { label: "Connesso", color: "#10B981" },
};

export const JOB_STATES = {
  queued: { label: "In coda", color: "#6B7280" },
  processing: { label: "In elaborazione", color: "#06B6D4" },
  requires_confirmation: { label: "Richiede conferma", color: "#F59E0B" },
  completed: { label: "Completato", color: "#10B981" },
  failed: { label: "Fallito", color: "#EF4444" },
  retryable: { label: "Ritentabile", color: "#F59E0B" },
  cancelled: { label: "Annullato", color: "#6B7280" },
};

export const ARCHIVE_TABS = [
  ["", "Tutti"], ["fatture", "Fatture"], ["scontrini", "Scontrini"], ["note_spese", "Note spese"],
  ["contratti", "Contratti"], ["assicurazioni", "Assicurazioni"], ["banche", "Banche"],
  ["personale", "Personale"], ["fisco", "Fisco / IVA"], ["corrispondenza", "Corrispondenza"], ["altro", "Altro"],
];

export const PAYMENT_LABELS = {
  contanti: "Contanti", carta_aziendale: "Carta aziendale", carta_personale: "Carta personale (da rimborsare)",
  banca: "Banca / bonifico", altro: "Altro", da_determinare: "Da determinare",
};
